import "./styles.css";
import * as THREE from "three";
import { Text } from "./Text";
import TouchTexture from "./TouchTexture";
import { EffectComposer, RenderPass, EffectPass } from "postprocessing";
import { WaterEffect } from "./WaterEffect";

console.clear();

function getLines(text, maxWidth, textSize) { // split the words in the text to fit the size of the screen
  var words = text.split(" ");
  var lines = [];
  var currentLine = words[0];
  let canvas = document.getElementById("Canvas");
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  let ctx = canvas.getContext("2d");
  // console.log(canvas.width);
  // console.log(textSize);

  for (var i = 1; i < words.length; i++) {
    var word = words[i];
    var width = textSize * ctx.measureText(currentLine + " " + word).width;
    // console.log(width);
    if (width < canvas.width) { // canvas.width (size of the window) vs maxWidth
      currentLine += " " + word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  }
  lines.push(currentLine);
  let metrics = ctx.measureText(currentLine);
  let actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
  // console.log(actualHeight * lines.length);
  let fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
  // console.log(fontHeight * lines.length);
  return [lines, actualHeight * lines.length * textSize];
}

export class App {
  constructor() {
    this.renderer = new THREE.WebGLRenderer({
      canvas: document.querySelector("#drawingCanvas"),
      antialias: false
    });
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.composer = new EffectComposer(this.renderer);
    this.camera = new THREE.PerspectiveCamera(
      45,
      window.innerWidth / window.innerHeight,
      0.1,
      10000
    );
    this.camera.position.z = 1100; // initial value = 50
    this.disposed = false;
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(0xffffff);
    this.clock = new THREE.Clock();
    this.assets = {};
    this.raycaster = new THREE.Raycaster();
    this.hitObjects = [];
    this.touchTexture = new TouchTexture();
    this.data = {
      text: ["despoina touska", "machine learning enthusiast", "Hello! I am a Machine Learning Research Engineer with a focus on Computer Vision techniques based in Thessaloniki. My roots are in computer science and software development, but my passion lies in exploring new ways of using AI models towards new realms connecting the digital with the physical world. I firmly believe in the power of open-source, experimentation and collaboration. I love learning new techniques in software creation to keep up to date with the latest tech trends and continually improve my skills."]
    };

    /// Position of text ///////////////////////////////////
    let cnv_width = document.querySelector("#drawingCanvas").width;
    this.subjects = [];
    let scl1 = 3.2;
    let scl2 = 1.6;
    let scl3 = 1.2;

    let pos1 = window.innerHeight * 0.3; // 250; // It is the position where the text begins

    let lineSizeName = 10;
    let lineSizeTitle = 3;
    let lineSizeBio = 4;

    let linesGap = 140;
    let linesGapBio = 180;

    let gapNameTitle = 30; // window.innerWidth * 0.01; 
    let gapTitleBio = 200;

    // Make the text responsive
    if (window.innerWidth <= 280) {
      pos1 = window.innerHeight * 1.5;
      scl1 = 3.3;
      scl2 = 2.0;
      gapNameTitle = -300;
      scl3 = 1.3;
      lineSizeBio = 2.1;
      gapTitleBio = -200;
    } else if (window.innerWidth < 420) {
      pos1 = window.innerHeight * 1.2;
      scl1 = 3.3;
      scl2 = 2.0;
      gapNameTitle = -150;
      scl3 = 1.3;
      lineSizeName = 5;
      lineSizeBio = 2.2;//2.4;
      gapTitleBio = 0;
      lineSizeTitle = 3.3;
    } else if (window.innerWidth < 780) {
      pos1 = window.innerHeight * 0.5;
      lineSizeName = 5;
      scl1 = 4.2;
      scl2 = 2.2;
      gapNameTitle = -50;
      scl3 = 1.5;
      lineSizeBio = 2.9;
    } else if (window.innerWidth < 1070) {
      pos1 = window.innerHeight * 0.4;
      scl1 = 4.0;
      scl2 = 2.2;
      gapNameTitle = 0;
      scl3 = 1.5;
      lineSizeBio = 3.6;
    } else if (window.innerWidth < 1200) {
      pos1 = window.innerHeight * 0.3;
      scl1 = 4.2;
      scl2 = 2.3;
      gapNameTitle = 50;
      scl3 = 1.3;
      lineSizeBio = 3.3;
    }
    // Get the lines of the text according to the window size
    let [nameLines, nameHeight] = getLines(this.data.text[0], cnv_width, lineSizeName); // for the name 20 works
    let [titleLines, titleHeight] = getLines(this.data.text[1], cnv_width, lineSizeTitle); // for the job title
    let [bioLines, bioHeight] = getLines(this.data.text[2], cnv_width, lineSizeBio); // for the paragraph
    let totalTextHeight = nameHeight + titleHeight + bioHeight;
    console.log(pos1);
    // console.log(pos1);
    // console.log(totalTextHeight / window.innerHeight);
    // console.log(totalTextHeight);
    // console.log(window.innerHeight);
    // pos1 = window.innerHeight;
    // pos1 = totalTextHeight / 2;
    // Define the position of the text on the page ///////////////////////////////////////////////////
    for (let indxLine = 0; indxLine < nameLines.length; indxLine++) {
      this.subjects.push(new Text(this, nameLines[indxLine], pos1, scl1));
      pos1 -= linesGap; // TODO: you can adjust!
    }
    pos1 += linesGap - gapNameTitle;
    for (let indxLine = 0; indxLine < titleLines.length; indxLine++) {
      this.subjects.push(new Text(this, titleLines[indxLine], pos1, scl2));
      pos1 -= linesGap; // TODO: you can adjust!
    }
    pos1 += linesGap - gapTitleBio;
    for (let indxLine = 0; indxLine < bioLines.length; indxLine++) {
      this.subjects.push(new Text(this, bioLines[indxLine], pos1, scl3)); // textSize = 6
      pos1 -= linesGapBio; // TODO: you can adjust!
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////
    this.tick = this.tick.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);

    this.init = this.init.bind(this);
    this.loader = new Loader();
    this.loadAssets().then(this.init);
  }
  loadAssets() {
    const loader = this.loader;
    const assets = this.assets;
    return new Promise((resolve, reject) => {
      // loadTextAssets(assets, loader);

      this.subjects.forEach(subject => subject.load(loader));

      loader.onComplete = () => {
        resolve();
      };
    });
  }
  initComposer() {
    const renderPass = new RenderPass(this.scene, this.camera);
    this.waterEffect = new WaterEffect({ texture: this.touchTexture.texture });
    const waterPass = new EffectPass(this.camera, this.waterEffect);
    waterPass.renderToScreen = true;
    renderPass.renderToScreen = false;
    this.composer.addPass(renderPass);
    this.composer.addPass(waterPass);
  }
  init() {
    this.touchTexture.initTexture();
    const assets = this.assets;
    this.subjects.forEach(subject => subject.init());
    this.initComposer();
    this.tick();

    window.addEventListener("resize", this.onResize);
    window.addEventListener("mousemove", this.onMouseMove);
    window.addEventListener("touchmove", this.onTouchMove);
  }
  onTouchMove(ev) {
    const touch = ev.targetTouches[0];
    this.onMouseMove({ clientX: touch.clientX, clientY: touch.clientY });
  }
  onMouseMove(ev) {
    const raycaster = this.raycaster;

    function getCursorPosition(canvas, event) {
      const rect = canvas.getBoundingClientRect()
      const x = event.clientX - rect.left
      const y = event.clientY - rect.top
      //console.log("x: " + x + " y: " + y)
      return [x, y];
    }
    const canvas = document.querySelector("#drawingCanvas")
    const coordinates = getCursorPosition(canvas, ev); // take the coordinates of the canvas not the window

    this.mouse = {
      x: coordinates[0] / window.innerWidth,
      y: 1 - coordinates[1] / window.innerHeight
    };

    // this coordinates correspond to the current window view not to the canvas
    // that's why when the cursor moves to another session than the canvas we also have distortion in the text!
    // this.mouse = {
    //   x: ev.clientX / window.innerWidth,
    //   y: 1 - ev.clientY / window.innerHeight
    // };


    this.touchTexture.addTouch(this.mouse);


    raycaster.setFromCamera(
      {
        x: (ev.clientX / window.innerWidth) * 2 - 1,
        y: -(ev.clientY / window.innerHeight) * 2 + 1
      },
      this.camera
    );
    // var intersections = raycaster.intersectObjects(this.hitObjects);
    // if (intersections.length > 0) {
    //   const intersect = intersections[0];
    //   this.touchTexture.addTouch(intersect.uv);
    // }
    this.subjects.forEach(subject => {
      if (subject.onMouseMove) {
        subject.onMouseMove(ev);
      }
    });
  }
  addImagePlane() {
    const viewSize = this.getViewSize();

    let width = viewSize.width / 4.5;

    const geometry = new THREE.PlaneBufferGeometry(
      width,
      viewSize.height * 0.8,
      1,
      1
    );
    let x = -viewSize.width / 2 + width / 2 + viewSize.width / 5 / 1.5;

    let space = (viewSize.width - (viewSize.width / 5 / 1.5) * 2 - width) / 2;
    for (let i = 0; i < 3; i++) {
      const material = new THREE.MeshBasicMaterial({ color: 0x484848 });
      const mesh = new THREE.Mesh(geometry, material);
      mesh.position.x += x + i * space;
      this.scene.add(mesh);
    }
  }
  initTextPlane() {
    const viewSize = this.getViewSize();

    const geometry = new THREE.PlaneBufferGeometry(
      viewSize.width,
      viewSize.height,
      1,
      1
    );
    const material = new THREE.ShaderMaterial({
      uniforms: {
        uMap: new THREE.Uniform(this.touchTexture.texture),
        uLines: new THREE.Uniform(5),
        uLineWidth: new THREE.Uniform(0.01),
        uLineColor: new THREE.Uniform(new THREE.Color(0x202030))
      },
      transparent: true,
      fragmentShader: `
        uniform sampler2D uMap;
        uniform float uLines;
        uniform float uLineWidth;
        uniform vec3 uLineColor;
        varying vec2 vUv;
        void main(){
          vec3 color = vec3(1.);
          color = vec3(0.);
          float line = step(0.5-uLineWidth/2.,fract(vUv.x * uLines)) - step(0.50 +uLineWidth/2.,fract(vUv.x * uLines));
          color += line * uLineColor;
          gl_FragColor = vec4(uLineColor,line);
        }
      `,
      vertexShader: `
        varying vec2 vUv;

        void main(){
          vec3 pos = position.xyz;
          gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.);
          vUv = uv;
        }
      `
    });
    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.z = -0.001;
    this.scene.add(mesh);
  }
  getViewSize() {
    const fovInRadians = (this.camera.fov * Math.PI) / 180;
    const height = Math.abs(
      this.camera.position.z * Math.tan(fovInRadians / 2) * 2
    );

    return { width: height * this.camera.aspect, height };
  }
  dispose() {
    this.disposed = true;
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("mousemove", this.onMouseMove);
    this.scene.children.forEach(child => {
      child.material.dispose();
      child.geometry.dispose();
    });
    if (this.assets.glyphs) this.assets.glyphs.dispose();

    this.hitObjects.forEach(child => {
      if (child) {
        if (child.material) child.material.dispose();
        if (child.geometry) child.geometry.dispose();
        // child.dispose();
      }
    });
    if (this.touchTexture) this.touchTexture.texture.dispose();
    this.scene.dispose();
    this.renderer.dispose();
    this.composer.dispose();
  }
  update() {
    this.touchTexture.update();
    this.subjects.forEach(subject => {
      subject.update();
    });
  }
  render() {
    // this.renderer.render(this.scene, this.camera);
    this.composer.render(this.clock.getDelta());
  }
  tick() {
    if (this.disposed) return;
    this.render();
    this.update();
    requestAnimationFrame(this.tick);
  }
  onResize() {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();

    this.composer.setSize(window.innerWidth, window.innerHeight);
    this.subjects.forEach(subject => {
      subject.onResize(window.innerWidth, window.innerHeight);
    });
  }
}

class Loader {
  constructor() {
    this.items = [];
    this.loaded = [];
  }
  begin(name) {
    this.items.push(name);
  }
  end(name) {
    this.loaded.push(name);
    if (this.loaded.length === this.items.length) {
      this.onComplete();
    }
  }
  onComplete() { }
}
